import type { FunctionComponent } from 'react';
import { ProductHome } from '@atlaskit/atlassian-navigation';
import { AtlassianLogo } from '@atlaskit/logo';

const BlueAtlassianLogo = () => {
  return <AtlassianLogo appearance="brand" />;
};

const NavLogo: FunctionComponent = () => {
  return <ProductHome icon={BlueAtlassianLogo} logo={BlueAtlassianLogo} />;
};

export default NavLogo;
